import { render, staticRenderFns } from "./QuotesReport.vue?vue&type=template&id=27f6e07c&"
import script from "./QuotesReport.vue?vue&type=script&lang=js&"
export * from "./QuotesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports